import { graphql } from "relay-runtime"

export const deSaveCarePlanDataMutation = graphql`
  mutation deSaveCarePlanDataMutation($input: De_saveCarePlanDataInput!, $connections: [ID!]!) {
    saveCarePlanData: de_saveCarePlanData(input: $input) {
      carePlanPreviewOutput: de_CarePlanPreviewOutput {
        progressNoteId
        carePlanSummary @prependNode(connections: $connections, edgeTypeName: "De_carePlanSummaryEdge") {
          ...CarePlanSummaryFragment @relay(mask: false)
        }
        previewMarkdown
      }
    }
  }
`
